// import {
//   CHECKIN_SYNC_ENQUEUE,
//   CHECKIN_SYNC_UPDATE_STATUS,
//   CHECKIN_SYNC_REMOVE,
//   CLEAR_STORE,
// } from "../actionsTypes";

// const initialState = [];

// export default function checkinSync(state = initialState, action = {}) {
//   switch (action.type) {
//     case CHECKIN_SYNC_ENQUEUE:
//       return [
//         ...state.filter((item) => item.id !== action.payload.id),
//         action.payload,
//       ];
//     case CHECKIN_SYNC_UPDATE_STATUS:
//       return state.map((item) =>
//         item.id === action.payload.id
//           ? { ...item, ...action.payload.changes }
//           : item
//       );
//     case CHECKIN_SYNC_REMOVE:
//       return state.filter((item) => item.id !== action.payload.id);
//     case CLEAR_STORE:
//       return initialState;
//     default:
//       return state;
//   }
// }


import {
  CHECKIN_SYNC_ENQUEUE,
  CHECKIN_SYNC_UPDATE_STATUS,
  CHECKIN_SYNC_REMOVE,
  CLEAR_STORE,
} from "../actionsTypes";
import { CHECKIN_SYNC_STATUS } from "common/Constants";

const initialState = [];

export default function checkinSync(state = initialState, action = {}) {
  switch (action.type) {
    case CHECKIN_SYNC_ENQUEUE:
      return [
        ...state.filter((item) => item.id !== action.payload.id),
        action.payload,
      ];
    case CHECKIN_SYNC_UPDATE_STATUS:
      return state.map((item) =>
        item.id === action.payload.id
          ? { ...item, ...action.payload.changes }
          : item
      );
    case CHECKIN_SYNC_REMOVE:
      return state.filter((item) => item.id !== action.payload.id);
    case CLEAR_STORE:
      // clearStore() runs on logout. Wiping this slice would silently
      // delete any check-in that hasn't reached the server yet (PENDING /
      // SYNCING / FAILED). Only drop entries that are already SYNCED —
      // keep everything else so it resumes once the app reloads.
      return state.filter(
        (item) => item.status !== CHECKIN_SYNC_STATUS.SYNCED
      );
    default:
      return state;
  }
}